"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _action = _interopRequireDefault(require("./action"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GenerateComponent = /*#__PURE__*/function (_Action) {
  (0, _inherits2.default)(GenerateComponent, _Action);

  var _super = _createSuper(GenerateComponent);

  function GenerateComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, GenerateComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'GenerateComponent');
    return _this;
  }

  (0, _createClass2.default)(GenerateComponent, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(GenerateComponent.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [// Note: we are no longer using a componentFactory, as we now opt to generate the
          // component from a string. This in turn, allows us to make any aspect of the component
          // dynamic, including the component type.
          //
          // In the future, we may want to bring back the componentFactory functionality, but for
          // now, we are opting to keep things simple and provide a single way to generate
          // components--one that works for all use cases.
          //
          // {
          //   name: 'componentFactory', component: 'Field', required: true,
          // },
          {
            // Use a string instead of object so that we can dynamically change any detail
            name: 'definition',
            component: 'TextField',
            required: true
          }]
        }
      });
    }
  }, {
    key: "act",
    value: function () {
      var _act = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var definition;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // const factory = this.get('componentFactory');
                // return factory.produce();
                definition = this.get('definition'); // Note: we use this._registrar.compiler to avoid a circular dependency

                return _context.abrupt("return", this._registrar.compiler.newComponent(JSON.parse(definition)));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function act() {
        return _act.apply(this, arguments);
      }

      return act;
    }()
  }]);
  return GenerateComponent;
}(_action.default);

exports.default = GenerateComponent;